import React, { useEffect, useRef, useState } from 'react';
import {
  LegalTemplate as LegalTemplateImport,
  LegalTemplateOwnProps,
} from '../../../../../../core/screens/Legal/organisms/LegalTemplate/LegalTemplate';
import { ContentOverlay } from '../../../../../molecules/ContentOverlay/ContentOverlay';
import { useAnalytics } from '../../../../../../core/Analytics/AnalyticsProvider';
import { PageView } from '../../../../../../models/analytics';
import { UnderlinedTextButton } from '../../../../../atoms/Button/TextButton';

export type DocumentOverlayLinkProps = {
  documentUrl: string;
  pageView: PageView;
  testId?: string;
  /**
   * Label for the legal template overlay. Use to improve accessibility
   * */
  overlayAriaLabel?: string;
  LegalTemplate?: React.ComponentType<LegalTemplateOwnProps>;
};

export const DocumentOverlayLink: React.FC<DocumentOverlayLinkProps> = ({
  documentUrl,
  pageView,
  testId,
  children,
  overlayAriaLabel,
  LegalTemplate = LegalTemplateImport,
}) => {
  const { tinklinkAnalytics } = useAnalytics();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const ref = useRef<HTMLAnchorElement>(null);

  const close = () => {
    setIsOpen(false);

    if (ref.current) {
      ref.current.focus();
    }
  };

  const open = (event: { preventDefault: () => void }) => {
    event.preventDefault();
    setIsOpen(true);
  };

  useEffect(() => {
    if (isOpen) {
      tinklinkAnalytics.sendViewEvent({ view: pageView });
    }
  }, [isOpen, pageView, tinklinkAnalytics]);

  return (
    <>
      {isOpen && (
        <ContentOverlay>
          <LegalTemplate onBack={close} documentUrl={documentUrl} ariaLabel={overlayAriaLabel} />
        </ContentOverlay>
      )}
      <UnderlinedTextButton
        onClick={open}
        data-testid={testId}
        as="a"
        role="button"
        tabIndex={0}
        href=""
        ref={ref}
      >
        {children}
      </UnderlinedTextButton>
    </>
  );
};
